import Model from '@/models/Model'

export default class HrPreviredMutual extends Model {
    resource() {
        return 'hr_previred_mutual'
    }

    
}
